import { Link, useLocation } from "react-router-dom";

function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter(Boolean);

  return (
    <nav className="breadcrumbs">
      <Link to="/">Home</Link>

      {pathnames.map((name, index) => {
        const routeTo = "/" + pathnames.slice(0, index + 1).join("/");
        const isLast = index === pathnames.length - 1;

        return (
          <span key={routeTo}>
            {" / "}
            {isLast ? (
              <span>{formatLabel(name)}</span>
            ) : (
              <Link to={routeTo}>{formatLabel(name)}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}

const formatLabel = str =>
  str
    .replace("-", " ")
    .replace(/\b\w/g, c => c.toUpperCase());

export default Breadcrumbs;
